// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/index.js?{\"minimize\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-41a58dc0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./SwappingSquaresSpinner.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../vue-style-loader/lib/addStylesClient.js")("7f8d8399", content, false);
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js?{\"minimize\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-41a58dc0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./SwappingSquaresSpinner.vue", function() {
     var newContent = require("!!../../../../css-loader/index.js?{\"minimize\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-41a58dc0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./SwappingSquaresSpinner.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-41a58dc0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/epic-spinners/src/components/lib/SwappingSquaresSpinner.vue
// module id = 917
// module chunks = 0